export default function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }
    idx += 1;
  }
  return result;
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_filter.js
// module id = 215
// module chunks = 2 3 4 5 6 7 8 10